<template>
	<a-layout id="layout-trigger">
		<a-layout-sider :trigger="null" collapsible v-model="collapsed" :width="230">
			<div :class="{'logo-collapsed': collapsed, 'logo': !collapsed}"></div>
			<a-menu v-model="menuSelecionado" theme="light" mode="inline" @openChange="onOpenChange" :openKeys="openKeys" style="height: calc(100vh - 80px); overflow-y: auto; overflow-x: hidden;">
				<a-sub-menu v-for="menu in menus" :key="'menu_' + menu.menu.idMenu">
					<span slot="title">
						<a-icon :type="menu.menu.icone"/>
						<span>{{menu.menu.nome}}</span>
					</span>
					<a-menu-item v-show="menu.listaMenu.length > 0 && menu.listaMenu.some(s => s.listaMenu.length <= 0)"  v-for="submenu in menu.listaMenu" :key="'folha_' + submenu.menu.idMenu">
						<router-link :to="{ name: submenu.menu.rota }">
							<a-icon :type="submenu.menu.icone"/>
							<span>{{submenu.menu.nome}}</span>
							<a-badge v-if="submenu.menu.rota=='aprovacaoGestor'" :count="$store.state.global.qtdAprovaGestor" style="padding-left: 5px; padding-bottom: 15px;"/>
						</router-link>
					</a-menu-item>
					<a-sub-menu  v-show="menu.listaMenu.length > 0 && menu.listaMenu.some(s => s.listaMenu.length > 0)" v-for="submenu in menu.listaMenu" :key="'submenu_' + submenu.menu.idMenu">
						<span slot="title">
							<a-icon :type="submenu.menu.icone"/>
							<span>{{submenu.menu.nome}}</span>
						</span>
						<a-menu-item v-for="submenufilho in submenu.listaMenu" :key="'folhasub_' + submenufilho.menu.idMenu">
							<router-link :to="{ name: submenufilho.menu.rota }">
								<a-icon :type="submenufilho.menu.icone"/>
								<span>{{submenufilho.menu.nome}}</span>
							</router-link>
						</a-menu-item>
					</a-sub-menu>
				</a-sub-menu>
			</a-menu>
		</a-layout-sider>
		<a-layout>
			<a-layout-header class="layout-header">
				<a-row>
					<a-col :span="1">
						<a-icon
							class="trigger"
							:type="collapsed ? 'menu-unfold' : 'menu-fold'"
							@click="()=> collapsed = !collapsed"
						/>
					</a-col>
					<a-col :span="11">
						<a-icon 
							class="trigger" 
							type="home" 
							style="font-size: 18px;" 
							@click="redirectHome"/>
					</a-col>
					<a-popover placement="bottomRight" trigger="click" v-model="popoverVisible">						
						<a-card hoverable style="width: 300px;" slot="content" class="user-avatar-popover-card">
							<template class="ant-card-actions" slot="actions">
								<div v-if="this.$store.state.auth.idUser == 1" @click.prevent="redirectUsuarios">
									<a-icon type="setting"/>
									<span style="padding-left: 5px">Gerenc. Usuários</span>
								</div>
								<div v-else @click.prevent="alterarSenha">
									<a-icon type="tool"/>
									<span style="padding-left: 5px">Alterar senha</span>
								</div>
								<div @click.prevent="logout">
									<a-icon type="logout"/>
									<span style="padding-left: 5px">Sair</span>
								</div>
							</template>
							<a-row align="middle" style="font-size: 16px; color: rgba(0, 0, 0, 0.85); font-weight: 500;">
                                <a-col :span="4">
                                    <a-avatar icon="user"/>
                                </a-col>
                                <a-col :span="20">{{$store.state.auth.nome}}</a-col>
                            </a-row>
							<a-row align="bottom" style="text-align: center;">
                                <a-col :span="24">
                                    <span>{{$store.state.auth.email}}</span>
                                </a-col>
                            </a-row>
							<!-- <a-row align="bottom" style="text-align: center;">
                                <a-col :span="15">
                                    <span><a :href="linkManual" target="_blank">Termo de Uso</a></span>
                                </a-col>
                            </a-row> -->
						</a-card>
						<div class="user-avatar">
							<label for="avatar">{{$store.state.auth.nome}}</label>
							<a-avatar size="large" icon="user"/>
						</div>
					</a-popover>
					<div v-if="mostrarAjuda" style="z-index: 10; position: fixed; top: 75px; right: 35px;">
						<a-tooltip>
							<template slot="title">Ajuda</template>
							<a href="#"  @click="abrirLinkManual(numPage)">
								<a-icon type="question-circle" style="color: #213596; font-size: 15px;"/>
							</a>
						</a-tooltip>
					</div>
				</a-row>				
			</a-layout-header>
			<a-layout-content
				:style="{ margin: '16px 16px', padding: '24px', background: '#fff', height: '100%' }"
			>
				<a-row>
					<h3>{{$route.meta.description}}</h3>
					<portal-target name="page-menu"></portal-target>
				</a-row>
				<a-row>
					<router-view/>					
				</a-row>
			</a-layout-content>
		</a-layout>

		<spinner style="z-index:9999999999;" v-if="$root.loadingSpinner"/>

		<modal-component
			class="modal-component"
			title="Alterar Senha"
			ref="modalAlterarSenha"
			width="20%"
			:maskClosable="false"
		>
			<a-row style="margin-bottom: 20px;">
				<a-col :span="24">
					<a-row>
						<span class="tr-label tr-spanbold">Senha atual:</span>
					</a-row>
					<a-row>
						<a-input-password
							placeholder="Insira a senha atual"
							v-model="senhaAtual"
							:allowClear="senhaAtual!=''"
							:disabled="loading"
						>
							<a-icon slot="prefix" type="lock"/>
						</a-input-password>
					</a-row>
				</a-col>
			</a-row>
			<a-row style="margin-bottom: 20px;">
				<a-col :span="24">
					<a-row>
						<span class="tr-label tr-spanbold">Nova senha:</span>
					</a-row>
					<a-row>
						<a-input-password
							placeholder="Insira a nova senha"
							v-model="novaSenha"
							:allowClear="novaSenha!=''"
							:disabled="loading"
						>
							<a-icon slot="prefix" type="lock"/>
						</a-input-password>
					</a-row>
				</a-col>
			</a-row>
			<a-row style="margin-bottom: 10px;">
				<a-col :span="24">
					<a-row>
						<span class="tr-label tr-spanbold">Confirmação nova senha:</span>
					</a-row>
					<a-row>
						<a-input-password
							placeholder="Insira a confirmação nova senha"
							v-model="confirNovaSenha"
							:allowClear="confirNovaSenha!=''"
							:disabled="loading"
						>
							<a-icon slot="prefix" type="lock"/>
						</a-input-password>
					</a-row>
				</a-col>
			</a-row>
			<span slot="buttons">
				<a-row type="flex" justify="end" align="middle">					
					<a-col :span="24">					
						<a-button
							key="submit"
							type="primary"
							style="width: 100px;"
							@click.prevent="verificarSenhaAtual()"
						>Alterar</a-button>
					</a-col>
				</a-row>
			</span>
		</modal-component>

		<modal-component
			class="modal-component"
			title="Ajuda"
			ref="modalAjuda"
			width="16%"
			:maskClosable="false"
		>
			<a-row style="height: 80px;">
				<a-col :span="24" style="height: 100%; padding-right: 45px;">
					<a-layout style="height: 100%;">
						<a-layout-sider style="width: 60px; flex: unset; max-width: unset; min-width: unset; text-align: center;">							
							<a :href="linkManual" target="_blank">
								<a-icon :component="BookIcon" style="font-size: 40px;"/>
							</a>
						</a-layout-sider>
						<a-layout style="padding-left: 7px; background: #fff;">
							<a-layout-header style="height: unset; padding: unset; line-height: unset; background: #fff;">
								<a href="#" @click="abrirLinkManual(1)" style="text-decoration: underline;">Abrir Manual do Produto</a>
							</a-layout-header>
							<a-layout-content style="height: 100%; background: #fff; font-size: 12px; padding-top: 5px;">
								Veja instruções detalhadas sobre como usar a plataforma
							</a-layout-content>
						</a-layout>
					</a-layout>
				</a-col>	
			</a-row>
		</modal-component>

	</a-layout>
</template>

<script>
import BreadComponent from "@/components/BreadComponent.vue";
import { DO_LOGOUT} from "@/store/actions";
import { SET_PERMISSAO } from "@/store/mutations";
import { showNotificationError } from "@/util/showNotification";
import { showNotificationSucess } from "@/util/showNotification";
import Spinner from "@/components/LoadComponent";
import ModalComponent from "@/components/ModalComponent";
import PortalCredencialWebApi from "@/API/PortalCredencialWebApi";
import BookIcon from "@/assets/book.svg";

export default {
	name: "home",
	components: { BreadComponent, Spinner, ModalComponent },
	beforeCreate() {
		this.form = this.$form.createForm(this);
	},
	created() {		
		this.carregarMenus();
	},
	data() {
		return {			
			collapsed: false,
			rootSubmenuKeys: [],
			rootSubSubmenuKeys: [],
			openKeys: [],
			lastSubKey: null,
			menus: [],
			menuSelecionado: [],
			timer: null,
			popoverVisible: false,
			senhaAtual: '',
            novaSenha: '',
            confirNovaSenha: '',
            loading: false,
			BookIcon,
			linkManual: '',
			numPage: 1,
			mostrarAjuda: false,
		};
	},
	mounted() {
		this.openKeys = ['menu_1'];		
		this.linkManual = this.$store.state.global.urlManual;
	},
    beforeUpdate() {
        this.validarPermissao();
    },
	computed: {
		hrefTarget () {
			return (this.enabled ? "_blank" : "_self")
		}
	},
	watch: {
		'$route' () {			
			switch (this.$route.name) {
				case 'principal':
					this.mostrarAjuda = false;
					this.openKeys = ['menu_1'];
					this.menuSelecionado = [];
					this.numPage = 1;
					break;

				case 'usuario':
					if (this.openKeys.length == 0)
						this.openKeys = ['menu_1'];
					this.menuSelecionado = ["folha_2"];
					this.mostrarAjuda = true;
					this.numPage = 16;
					break;

				case 'perfil':
					this.mostrarAjuda = true;
					this.numPage = 8; 
					break;

				default:
					this.mostrarAjuda = false;
				 	this.numPage = 1;
				 	break;
			}
		},
	},
	methods: {
		validarMenu(value) {
			return value < 0;
		},
		carregarMenus() {
			this.menus = this.$store.state.access.menu;
			this.rootSubmenuKeys = this.menus.filter( m => { return m.idMenuPai == null } ).map( a => { return 'menu_' + a.menu.idMenu });
			this.menus.forEach(f => {
				if ((f.listaMenu.length > 0) && f.listaMenu.some(s => s.listaMenu.length > 0))
				{
					this.rootSubSubmenuKeys.push(f.listaMenu.filter(x => x.menu.idMenuPai == f.menu.idMenu).map(a => { return 'submenu_' + a.menu.idMenu }));
				}				
			});			
		},
        validarPermissao() {
            if (!this.$store.state.auth.user_no_permission.temPermissao) {
                showNotificationError(this, "Permissão", this.$store.state.auth.user_no_permission.msg);
                this.$store.commit(SET_PERMISSAO, { user_no_permission: { temPermissao: true } });
            }
        },
		onOpenChange(openKeys) {			
			const latestOpenKey = openKeys.find(
				key => this.openKeys.indexOf(key) === -1
			);

			let subKey = null;
			if (this.rootSubmenuKeys.indexOf(latestOpenKey) > -1) {
				this.lastSubKey = latestOpenKey;
			} else {
				subKey = latestOpenKey;
			}
			if (this.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
				this.openKeys = subKey ? [this.lastSubKey, subKey] : openKeys;
			} else {
				this.openKeys = latestOpenKey ? [latestOpenKey] : [];
			}
		},
		redirectUsuarios() {
			this.popoverVisible = false;
			this.$router.replace({ name: "usuario" });
		},
		redirectHome() {
			this.popoverVisible = false;
			this.$router.replace({ name: "home" });
		},
		alterarSenha() {
			this.popoverVisible = false;
			this.$router.replace({ name: "home" });
			this.$refs.modalAlterarSenha.showModal();
		},
		logout() {
			this.$store
				.dispatch(DO_LOGOUT)
				.then()
				.catch(error => {
					showNotificationError(this, "Home", error.res.Message);
				});

			this.$router.replace({ name: "login" });
		},
		verificarSenhaAtual(){
            if (this.senhaAtual.trim() == ''){
                showNotificationError(this, "Alterar senha", "Senha atual é um campo obrigatório.");
				return;
            }
            if (this.novaSenha.trim() == ''){
                showNotificationError(this, "Alterar senha", "Nova senha é um campo obrigatório.");
				return;
            }
            if (this.confirNovaSenha.trim() == ''){
                showNotificationError(this, "Alterar senha", "Confirmação senha é um campo obrigatório.");
				return;
            }
            if (this.novaSenha.toLowerCase() != this.confirNovaSenha.toLowerCase()){
				showNotificationError(this, "Alterar senha", "A nova senha e confirmação nova senha informadas não combinam!");				
				return;
			}
            PortalCredencialWebApi.verificarSenhaAtual(this.$store.state.auth.idUser, this.senhaAtual.trim())
                .then(res => {
					if (res.data.statusCode != 200) {						
						showNotificationError(this, "Alterar senha", res.data.errorMessage);
                        return;
                    } else {
                        this.salvarNovaSenha();
                    }
				})
				.catch(res => {					
					showNotificationError(this, "Alterar senha", "Erro ao tentar alterar senha.");
                    return;
				});            
        },
        salvarNovaSenha(){
            PortalCredencialWebApi.atualizarSenha(this.$store.state.auth.idUser, this.novaSenha.trim())
				.then(res => {
					if (res.data.statusCode == 200) {
						this.$refs.modalAlterarSenha.handleCancel();
						showNotificationSucess(this, "Alterar senha", res.data.result);						
					} else
						showNotificationError(this, "Alterar senha", res.data.errorMessage);
				})
				.catch(res => {					
					showNotificationError(this, "Alterar senha", "Erro ao tentar alterar senha.");
				});
        },
		abrirModalAjuda() {
			this.$refs.modalAjuda.showModal();
		},
		abrirLinkManual(parNumPage) {
			window.open(this.linkManual+"#page="+parNumPage, '_blank');
		}
	},
	beforeDestroy(){
		if (this.timer != null)		
			clearInterval(this.timer);
	}
};
</script>

<style>
.user-avatar {
	cursor: pointer;
	display: inline-block;
	overflow: auto;
	line-height: 64px;
	float: right;
	margin-right: 20px;
}

.user-avatar label {
	padding-right: 15px;
	cursor: pointer;
}

.ant-layout-content h3 {
	font-weight: bold;
}

#layout-trigger {
	height: 100%;
	text-align: left;
	color: #fff;
}

.ant-layout-sider {
	background-color: #fff;
}

.ant-layout {
	overflow-y: hidden;
}

#layout-trigger .trigger {
	font-size: 18px;
	line-height: 64px;
	padding: 0 24px;
	cursor: pointer;
	transition: color 0.3s;
}

#layout-trigger .trigger:hover {
	color: #1890ff;
}

#layout-trigger .logo {
	height: 64px;
	background: url(../assets/Novo.png); 
	margin: 0px;
	text-align: center;
	background-size: 90%;
	background-repeat: no-repeat;
	background-position: center;
	background-color: #041c43;
}

#layout-trigger .logo-collapsed {
	height: 64px;
	background: url(../assets/TribunalLight.png);
	margin: 0px;
	text-align: center;
	background-size: 90%;
	background-repeat: no-repeat;
	background-position: center;
	background-color: #041c43;
}

#layout-trigger .layout-header {
	background: #041c43;
	padding: 0;
	text-align: left;
}

#layout-trigger .breadcrumb {
	height: 100%;
	line-height: 64px;
	cursor: pointer;
}

.user-avatar-popover-card {
	margin: -12px -18px;
}

.ant-modal-title {
	color: #fff;
	font-family: "Segoe UI", "Segoe UI Emoji", "Segoe UI Symbol", "Courier New",
		Courier, monospace;
}

.ant-modal-close-x {
	color: #fff;
}

.ant-modal-content {
	border-radius: 6px;
}

.ant-badge-count {
	background: #041c43;
}

.ant-tabs-bar {
	margin: 0px !important;
}

.ant-collapse-content > .ant-collapse-content-box {
	padding: 5px !important;
}

.ant-table-thead > tr:first-child > th {
	background: #b8c2cc;
}

.ant-table-header {
	margin-bottom: 0px !important;
    overflow: hidden !important;
}

.ant-table-thead > tr > th .ant-table-column-sorter {
	color: #ffffff;
}

.ant-table-thead > tr > th .anticon-filter {
	color: #ffffff;
}

.ant-table-thead > tr > th .ant-table-filter-icon > svg {
	color: #ffffff;
}

.ant-badge-count {
    background: #f5222d !important;
	min-width: 19px !important;
    height: 19px !important;
}

.tr-label:before {
    content: '* ';
    color: #f5222d;
}

.ant-table-small > .ant-table-content > .ant-table-body > table > .ant-table-thead > tr > th {
  background-color: #b8c2cc !important;
}

.ant-menu-submenu-popup {
	width: 175px;
}

.tr-inputDisableReadOnly {
    background-color: #f5f5f5;
    opacity: 1;
    cursor: not-allowed;
}

.tr-inputDisableReadOnly:hover {
    border-color: #e6d8d8;
    border-right-width: 1px !important;
}

.ant-tabs-nav .ant-tabs-tab-active {
    font-weight: 550;
}

.ant-tree li .ant-tree-node-content-wrapper.ant-tree-node-selected {
    background-color: #b8c2cc;
}

div .ant-row-flex {
	margin-top: 5px;
	margin-bottom: 10px;
}

.ant-input-disabled{
	color: black;
}

.ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {
    background-color: #ccd5dc;
}

.ant-menu-item > a {
    color: #213596 !important;
}

.ant-menu-submenu-title {
    color: #213596 !important;
	font-weight: 550;
}

.tr-spanbold{
	color: #000;
	font-family: "Segoe UI", "Segoe UI Emoji", "Segoe UI Symbol", "Courier New",
		Courier, monospace;
	font-weight: bold;
}
</style>